// extracted by mini-css-extract-plugin
export default {"content-wrapper":"choose-products_content-wrapper__122KN","content":"choose-products_content__g6kzx"};